import React from "react";
import { Link } from "react-router-dom";
import { Box, Button, Grid, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";

import { ROUTES } from "@/utils/navigation";
import { useGetProductsQuery } from "@/redux-store/api/marketingApi";
import useResponsive from "@/hooks/useResponsive";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import ProductCard from "./ProductCard";
import { productLinkStyles } from "../styles";
import "./styles.css";

interface IProps {
  closeDropDown: () => void;
}

const Products: React.FC<IProps> = ({ closeDropDown }) => {
  const isMobile = useResponsive("down", "lg");
  const { data: products } = useGetProductsQuery({});
  return (
    <>
      <Button
        variant="text"
        color="secondary"
        component={Link}
        to={ROUTES.solutions}
        onClick={closeDropDown}
        sx={productLinkStyles}
        endIcon={
          <ArrowForwardIosIcon fontSize="small" sx={{ color: "text.accent" }} />
        }
      >
        <Typography variant="h4" component="span">
          Our Products
        </Typography>
      </Button>

      {products && (
        <>
          {isMobile ? (
            // Mobile menu - slider
            <Box
              component={Swiper}
              sx={{ maxWidth: "100%" }}
              spaceBetween={24}
              loop={true}
              centeredSlides={true}
              slidesPerView="auto"
              className="product-swiper"
            >
              {products.map((product) => (
                <SwiperSlide key={product.id}>
                  <ProductCard
                    product={product}
                    closeDropDown={closeDropDown}
                  />
                </SwiperSlide>
              ))}
            </Box>
          ) : (
            // Desktop menu
            <Grid container rowSpacing={5} columnSpacing={3}>
              {products.map((product) => (
                <Grid key={product.id} item sm={6}>
                  <ProductCard
                    product={product}
                    closeDropDown={closeDropDown}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </>
      )}
    </>
  );
};

export default Products;
